import { useState, useEffect, useContext } from "react";
import { checkUserPermission } from "../../../../common/UserPermission";
import Select from "react-select";
import axios from "axios";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../../common/Constant";
import config from "../../../../config/config";
import CurrencySymbols from "../../../../common/CurrencySymbol";
import { AppContext } from "../../../../context/AppContext";
import { toastError, toastSuccess } from "../../../../common/Toast";
// import { AppContext } from "../../../../context/AppContext";
let PERMISSION_DELETE = "delete-attributes";

let sum;
// update user permission data by login user id
export function updateDataForTotal(p_Total) {
  sum = p_Total;
}

// return only list of user permission data
export function GetDataForTotal() {
  return sum;
}

const BankDepositRows = ({
  rowsData,
  deleteTableRows,
  handleChange,
  callback,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [AccountFrom, setAccountFrom] = useState([]);
  const [AccountPerson, setAccountPerson] = useState([]);
  const [AccountName, setAccountName] = useState("");
  const [paymentTypeDropdown, setPaymentTypeDropdown] = useState([]);
  const [Total, setTotal] = useState(0);
  const token = localStorage.getItem("Token");
  const { CurrencySymbol, FractionDigits } = useContext(AppContext);

  let sumTotal = 0;

  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setShowDeleteModal(true);
  };

  console.log(AccountName, "rowsData");

  useEffect(() => {
    const value = rowsData.reduce((acc, curr) => {
      return acc + Number(curr["Amount"]);
    }, 0);
    callback(value);
  }, [rowsData]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: "auto", // Auto width based on content
      minWidth: "200px", // Optional: Set a minimum width
      whiteSpace: "nowrap",
      borderRadius: "8px",
    }),
    menu: (provided) => ({
      ...provided,
      width: "auto", // Auto width for the dropdown menu as well
      minWidth: "200px", // Optional: Set a minimum width
    }),
  };

  const handleAccount = (index, event) => {
    setAccountName(event.AccountName);
    let evnt = {
      target: {
        name: "AccountIDs",
        value: event.value,
        quickbookid: event.quickbookid,
        accountname: event.AccountName
      },
    };
    handleChange(index, evnt);
  };

  const handlePayment = (index, event) => {
    let evnt = {
      target: {
        name: "PaymentMethodID",
        value: event.value,
        quickbookid: event.QuickbookID,
      },
    };
    handleChange(index, evnt);
  };

  const handleUserType = (index, event) => {
    console.log("event", event);
    let evnt = {
      target: {
        name: "UserType",
        value: event.IsCustomer,
      },
    };

    handleChange(index, evnt);
  };

  const handleName = (index, event) => {
    console.log("event", event.value);
    let evnt = {
      target: {
        name: "CustomerID",
        value: event.value,
        quickbookid: event.QuickbookId,
        // IsCustomer: event.IsCustomer,
      },
    };
    handleChange(index, evnt);
  };
  // const handleUserType = (index, event) => {
  //   console.log("event", event);
  //   let evnt = {
  //     target: {
  //       name: "CustomerID",
  //       value: event.IsCustomer,
  //     },
  //   };

  //   handleChange(index, evnt);
  // };

  const handleConfirmDelete = () => {
    deleteTableRows(deleteIndex);
    setShowDeleteModal(false);
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };

  const handleClose = () => {
    setShowDeleteModal(false);
  };

  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",

  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: (provided, state) => {
  //     const { top, left } = state.selectProps.menuPosition;
  //     return {
  //       ...provided,
  //       boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //       position: "absolute",
  //       zIndex: "999",
  //       background: "#f8f8f8",
  //       width: "100%",
  //       top: `${top}px`,
  //       left: `${left}px`,
  //       maxHeight: "200px",
  //       overflowY: "auto", // use "auto" instead of "scroll" to enable scrolling only when needed
  //     };
  //   },

  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };

  // const selectStyles = {
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc",
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc",
  //     },
  //   }),
  //   menu: (provided, state) => ({
  //     ...provided,
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     zIndex: "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //     top: state.selectProps.menuPosition?.top ?? "unset",
  //     left: state.selectProps.menuPosition?.left ?? "unset",
  //     maxHeight: "none",
  //     overflowY: "auto",
  //   }),
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff",
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)",
  //     },
  //   }),
  // };

  const handleInputBoxChange = (index, field, value) => {
    let newRowsData = [...rowsData];
    newRowsData[index][field] = value;
    if (field === "Amount") {
      rowsData.forEach((data) => {
        console.log("data.Amount -==", data.Amount);
        sumTotal =
          parseFloat(sumTotal) +
          parseFloat(data.Amount == "" ? 0 : data.Amount);
        updateDataForTotal(sumTotal);
        // setSubTotal(sumTotal)
      });
    }

    setTotal(sumTotal);
  };

  console.log("Total ==>>", Total);

  useEffect(() => {
    axios
      .get(
        `${config.appointmentBaseUrl}/appointments/appointmentpersonddl/?isCustomer=0`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setAccountPerson(res.data.ResponseData);
      });

    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("response ==>", res.data.ResponseData);
        // const filteredData = res.data.ResponseData.filter(
        //   (item) =>
        //     !["Accounts Payable (A/P)", "Accounts Receivable (A/R)"].includes(
        //       item.AccountName
        //     )
        // );

        // setAccountFrom(filteredData);

        setAccountFrom(res.data.ResponseData);
      });

    axios
      .get(`${config.generalBaseUrl}/generals/paymentdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })

      .then((res) => {
        setPaymentTypeDropdown(res.data.ResponseData);
      });
  }, []);

  if (rowsData != "")
    return rowsData.map((data, index) => {
      const {
        BankdepositID,
        CustomerID,
        AccountIDs,
        Description,
        PaymentMethodID,
        RefNo,
        Amount,
        accountname,
      } = data;


      console.log(data,"7854655465");
      

      let appointmentPersonOptions = [];
      let UserType = [];
      const Person = AccountPerson.map((u, i) => {
        if (u.IsCustomer == 1) {
          UserType = "Customer";
        } else if (u.IsCustomer == 0) {
          UserType = "Supplier";
        } else {
          UserType = "Employee";
        }
        appointmentPersonOptions[i] = {
          label: u.FirstName + " " + `   (${UserType})`,
          value: u.Id,
          IsCustomer: u.IsCustomer,
          QuickbookId: u.QuickBookId,
        };
      });

      let categoryOption = [];
      const FundsFrom = AccountFrom.map((u, i) => {
        categoryOption[i] = {
          label: u.Name,
          value: u.ID,
          quickbookid: u.QuickbookId,
          AccountName: u.AccountName,
          parentName: u.ParentName ? u.ParentName.trim() : "",
          AccountType: u.AccountType,
        };
      });

      let PaymentOption = [];
      const PaymentOpt = paymentTypeDropdown.map((u, i) => {
        PaymentOption[i] = {
          label: u.Paymenttypename,
          value: u.ID,
          QuickbookID: u.PaymentQuickbookId,
        };
      });

      // console.log(rowsData,"rowsData")
      // console.log(categoryOption,"categoryOption")

      return (
        <>
          <tr key={index}>
            <td>{index + 1}</td>
            <td>
              <Select
                onChange={(event) => {
                  if (data?.Isrestricted == 0) {
                    handleName(index, event);
                    handleUserType(index, event);
                  }
                }}
                options={
                  accountname != ""
                  ? accountname == "Accounts Payable (A/P)"
                    ? appointmentPersonOptions.filter(
                        (el) => el.IsCustomer == 0
                      )
                    : accountname == "Accounts Receivable (A/R)"
                    ? appointmentPersonOptions.filter(
                        (el) => el.IsCustomer == 1
                      )
                    : appointmentPersonOptions
                  : appointmentPersonOptions}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                id="CustomerID"
                name="CustomerID"
                // styles={CUSTOM_SELECT_DROPDOWN_STYLE }
                styles={customStyles}
                value={appointmentPersonOptions
                  ?.filter(
                    (el) =>
                      el.IsCustomer ==
                      (data.UserType == 1 ? 1 : data.UserType == 2 ? 2 : 0)
                  )
                  ?.find((item, index) => item.value == CustomerID)}
              />
            </td>
            <td>
              <Select
                onChange={(event) => {
                  if (data?.Isrestricted == 0) {
                    handleAccount(index, event, data);
                  }
                }}
                options={categoryOption}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                id="AccountIDs"
                name="AccountIDs"
                styles={customStyles}
                value={categoryOption.find(
                  (item, index) => item.value == AccountIDs
                )} 
                formatOptionLabel={({ label, parentName, AccountType }) => (
                      <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                        <span>{label}</span>
                        <span style={{ fontStyle: "italic", color: "#666", marginLeft: "1rem" }}>
                          {parentName ? `Sub-account of ${parentName}` : AccountType}
                        </span>
                      </div>
                    )}
              />
            </td>
            <td>
              <input
                type="text"
                className="form-control"
                name="Description"
                onChange={(evnt) => {
                  if (data?.Isrestricted == 0) {
                    handleChange(index, evnt);
                  }
                }}
                value={Description}
              />
            </td>
            <td>
              <Select
                onChange={(event) => {  if (data?.Isrestricted == 0) { handlePayment(index, event) }}}
                options={PaymentOption}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                id="PaymentMethodID"
                name="PaymentMethodID"
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                value={PaymentOption.find(
                  (item, index) => item.value == PaymentMethodID
                )}
              />
            </td>
            <td>
              <input
                type="number"
                className="form-control"
                name="RefNo"
                onChange={(evnt) => {
                  if (data?.Isrestricted == 0) {
                    handleChange(index, evnt);
                  }
                }}
                value={RefNo}
              />
            </td>
            <td>
              {/* <input
                type="number"
                className="form-control"
                name="Amount"
                onChange={(evnt) => {
                  const value = parseFloat(evnt.target.value); 

                  if (
                    AccountName === "Accounts Payable (A/P)" ||
                    AccountName === "Accounts Receivable (A/R)"
                  ) {
                    if (value >= 0) {
                      handleChange(index, evnt);
                      handleInputBoxChange(index, "Amount", value);
                    }
                  } else {
                    handleChange(index, evnt);
                    handleInputBoxChange(index, "Amount", value);
                  }
                }}
                value={Amount}
              /> */}
              <input
                type="text"
                className="form-control"
                name="Amount"
                value={`${CurrencySymbol} ${Amount === "" ? "" : Amount}`}
                onChange={(evnt) => {
                  if (data?.Isrestricted == 0) {
                    let value = evnt.target.value
                      .replace(CurrencySymbol, "")
                      .trim();

                    const isARorAP = AccountFrom?.some(
                      (acc) =>
                        acc.ID == AccountIDs &&
                        (acc.AccountName == 'Accounts Receivable (A/R)' || acc.AccountName == 'Accounts Payable (A/P)')
                    );

                    if (isARorAP && (value < 0 || isNaN(value))) {
                        toastError("Amount must be a positive number for Accounts Receivable (A/R) or Accounts Payable (A/P).");
                        return;
                      }

                    // If only "-" is entered, allow it (for negative values)
                    if (value === "-") {
                      handleInputBoxChange(index, "Amount", value);
                      return;
                    }

                    if (value === "") {
                      handleChange(index, {
                        ...evnt,
                        target: { ...evnt.target, value: 0 },
                      });
                      handleInputBoxChange(index, "Amount", "");
                      return;
                    }

                    if (
                      AccountName === "Accounts Payable (A/P)" ||
                      AccountName === "Accounts Receivable (A/R)"
                    ) {
                      if (!isNaN(value)) {
                        handleChange(index, evnt);
                        handleInputBoxChange(index, "Amount", value);
                      }
                    } else {
                      handleChange(index, evnt);
                      handleInputBoxChange(index, "Amount", value);
                    }
                  }
                }}
                onFocus={(event) => event.target.select()}
                onBlur={(event) => {
                  let rawValue = event.target.value
                    .replace(CurrencySymbol, "")
                    .trim();

                  // Handle case where only "-" is entered
                  if (rawValue === "-") {
                    event.target.value = `${CurrencySymbol} -0.00`;
                    handleInputBoxChange(index, "Amount", "-0.00");
                    return;
                  }

                  let numericValue = parseFloat(rawValue) || 0;
                  numericValue = numericValue.toFixed(2); // Format to 2 decimal places

                  event.target.value = `${CurrencySymbol} ${numericValue}`;
                  handleInputBoxChange(index, "Amount", numericValue);
                }}
              />
            </td>
            <td>
              <i
                className="fa fa-trash text-red fa-2x"
                data-bs-toggle="tooltip"
                title="Delete"
                onClick={() => {
                  if (data?.Isrestricted == 0) {
                    handleDeleteClick(index);
                  }
                }}
                data-bs-backdrop="static"
                data-bs-keyboard="false"
              />
              {/* Delete confirmation modal */}
              <div
                className={`modal ${showDeleteModal ? "d-block" : ""} `}
                tabIndex="-1"
              >
                <div
                  className="modal-dialog modal-sm modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h6 className="title-model">Confirmation</h6>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={handleClose}
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="row">
                        <div className="col-lg-12">
                          <p>Are you sure you want to delete this row?</p>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer justify-content-center">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleConfirmDelete}
                      >
                        Delete
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleCancelDelete}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </>
      );
    });
};

export default BankDepositRows;
